import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import useStyles from "./styles";
import { useSelector } from "react-redux";

const CustomerTestimonials = () => {
  const classes = useStyles();

  const testimonials = useSelector(state => state.testimonials.data);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <svg
        key={index}
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill={index < rating ? "#FFD700" : "#E0E0E0"}
        className={classes.star}
      >
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      </svg>
    ));
  };

  return (
    <div className={classes.testimonialsSec}>
      <div className='container'>
        <div className={classes.sectionHeader}>
          <h2 className={classes.heading}>What Our Customers Say</h2>
          <p className={classes.subheading}>
            Join thousands of satisfied customers who trust Avon Namkeen for authentic Indian snacks
          </p>
        </div>

        <div className="productSliderSec">
          <div className={classes.carouselContainer}>
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={4000}
              arrows={true}
              showDots={false}
              draggable={true}
              keyBoardControl={true}
              className={classes.carousel}
            >
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className={classes.testimonialCard}>
                  <div className={classes.testimonialHeader}>
                    <div className={classes.customerImage}>
                      <img 
                        src={'/images/user.png'} 
                        alt={testimonial.name}
                      />
                    </div>
                    <div className={classes.customerInfo}>
                      <h4 className={classes.customerName}>{testimonial.name}</h4>
                      <p className={classes.customerLocation}>{testimonial.company}</p>
                      <div className={classes.rating}>
                        {renderStars(5)}
                      </div>
                    </div>
                  </div>
                  
                  <div className={classes.testimonialContent}>
                    <p className={classes.testimonialComment}>"{testimonial.description}"</p>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerTestimonials;
